export const isOifEnabled = (type, loading, flag) => {
  if (type === 'label') return loading;
  return flag;
};
